import React from "react";
import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  return (
    <div className="privacy-container">
      {/* Header */}
      <header className="privacy-header">
        <h1>AI Privacy & Content Use Statement</h1>
        <p className="last-updated">Last Updated: August 2025</p>
      </header>

      {/* Content */}
      <main className="privacy-content">
        <ol>
          <li>
            <h2>Important Notice: Not HIPAA Compliant</h2>
            <p>
              This tool is not HIPAA-compliant and should not be used to store,
              transmit, or process Protected Health Information (PHI) as defined
              under HIPAA or other health privacy regulations. Users are
              responsible for ensuring that any content entered into the system
              does not contain personally identifiable patient information.
            </p>
          </li>

          <li>
            <h2>Purpose of the Tool</h2>
            <p>
              This tool is designed to assist with generating and structuring
              mental health notes, objectives, and related clinical
              documentation. It is intended for educational, administrative, and
              workflow support purposes only, not for diagnosis, treatment, or
              direct clinical decision-making.
            </p>
          </li>

          <li>
            <h2>Data Collection & Use</h2>
            <ul>
              <li>
                <strong>User Inputs:</strong> Any text, notes, or objectives
                entered into the system may be processed by the AI to generate
                responses.
              </li>
              <li>
                <strong>Storage:</strong> Input data may be stored temporarily
                or permanently for the purposes of improving the system,
                training underlying models, or providing continuity of service.
              </li>
              <li>
                <strong>Anonymization:</strong> Users are encouraged to
                de-identify all personal information prior to use.
              </li>
            </ul>
          </li>

          <li>
            <h2>Ownership, Reuse & Commercial Rights</h2>
            <ul>
              <li>
                <strong>Company Ownership:</strong> This AI tool, its underlying
                technology, and all AI-generated outputs are the proprietary
                content of <em>It Takes A Family</em>.
              </li>
              <li>
                <strong>Reuse for Improvement:</strong> It Takes A Family may
                reuse, adapt, or incorporate anonymized user content into system
                improvements, training datasets, or derivative tools.
              </li>
              <li>
                <strong>Commercial Rights:</strong> It Takes A Family reserves
                the right to use anonymized and aggregated data to enhance,
                expand, and eventually commercialize the tool in broader
                markets.
              </li>
              <li>
                <strong>User Rights:</strong> Users retain ownership of their
                original input but grant It Takes A Family a license to use
                anonymized content for research, improvement, and commercial
                purposes.
              </li>
            </ul>
          </li>

          <li>
            <h2>Security & Limitations</h2>
            <p>
              While reasonable measures are taken to protect stored content,
              absolute data security cannot be guaranteed. The tool should not
              be considered a secure or confidential platform for sensitive
              health records. Users are solely responsible for compliance with
              all applicable laws and organizational policies when using the
              tool.
            </p>
          </li>

          <li>
            <h2>Disclaimer of Liability</h2>
            <p>
              The tool is provided “as-is” without warranties of any kind.{" "}
              <em>It Takes A Family</em> disclaims liability for:
            </p>
            <ul>
              <li>Misuse of the tool for PHI storage or treatment decisions.</li>
              <li>Data breaches, unauthorized access, or unintended disclosures.</li>
              <li>
                Any direct or indirect harm resulting from reliance on
                AI-generated content.
              </li>
            </ul>
          </li>

          <li>
            <h2>Future Development & Market Use</h2>
            <p>This tool is part of an ongoing innovation process. As it evolves:</p>
            <ul>
              <li>
                Features may expand to include compliance-ready options (e.g.,
                HIPAA-compliant versions).
              </li>
              <li>
                <em>It Takes A Family</em> may introduce paid, licensed, or
                enterprise offerings.
              </li>
              <li>
                Input collected now may inform future commercial products and
                services.
              </li>
            </ul>
          </li>

          <li>
            <h2>Acceptance of Terms</h2>
            <ul>
              <li>Understand it is not HIPAA-compliant.</li>
              <li>
                Agree to remove identifying patient information before inputting
                content.
              </li>
              <li>
                Acknowledge that the AI and its outputs are the proprietary
                content of <em>It Takes A Family</em>.
              </li>
              <li>
                Consent to the reuse of anonymized content for improvement and
                commercialization.
              </li>
            </ul>
          </li>
        </ol>
      </main>
    </div>
  );
}
